import { Controller, useForm } from "react-hook-form";
import { useQuery } from "react-query";

import { nhomNguyenVatLieuApi } from "src/1/apis/nhom_nguyen_vat_lieu.api";
import { usePermissionCheck } from "src/1/common/components/others";
import { Magnifying } from "src/common/assets/icons";
import { CButton, CInput, CSelect } from "src/common/components/controls";
import { CActionGroup } from "src/common/components/others";
import { ENTITY_GROUP_CODE, PERMISSION_VALUE } from "src/configs/constant";
import { useGetMyStores } from "src/utils/hooks/options";

export const DinhMucTonKhoToolbar = ({
  params,
  canAdd,
  canEdit,
  canRemove,
  onAdd,
  onEdit,
  onRemove,
  onSearch,
}) => {
  //#region Data
  const checkPermission = usePermissionCheck();

  const { control, handleSubmit } = useForm({
    defaultValues: params,
  });

  const { stores } = useGetMyStores();

  const { data: groups = [] } = useQuery({
    queryKey: ["danh-sach-tat-ca-nhom-nvl"],
    queryFn: () => nhomNguyenVatLieuApi.getAll(),
    select: (response) =>
      response?.data?.data?.map((e) => ({
        ...e,
        id: e.code,
        value: e.code,
        label: e.name,
      })),
  });
  //#endregion

  //#region Event
  const onClick = (state) => {
    switch (state) {
      case "add":
        return onAdd();
      case "edit":
        return onEdit();
      case "remove":
        return onRemove();
      case "print":
        return;
    }
  };

  const search = handleSubmit(
    (d) => onSearch(d),
    (e) => noti("error", e),
  );
  //#endregion

  //#region Render
  return (
    <>
      <div>
        <CActionGroup
          onClick={onClick}
          canAdd={
            canAdd &&
            checkPermission({
              [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.CREATE,
            })
          }
          canEdit={
            canEdit &&
            checkPermission({
              [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.UPDATE,
            })
          }
          canRemove={
            canRemove &&
            checkPermission({
              [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.DELETE,
            })
          }
        />
      </div>

      <div className="mt-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Controller
            name="code"
            control={control}
            render={({ field }) => (
              <CInput
                {...field}
                label="Mã NVL"
                placeholder="Tìm kiếm theo mã NVL"
              />
            )}
          />
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <CInput
                {...field}
                label="Tên NVL"
                placeholder="Tìm kiếm theo tên NVL"
              />
            )}
          />
          <Controller
            name="store_code"
            control={control}
            render={({ field }) => (
              <CSelect
                {...field}
                label="Chi nhánh"
                options={stores}
                optionAll
                display="label"
                select="value"
                placeholder="Tất cả"
                className="min-w-[250px]"
              />
            )}
          />
          <Controller
            name="group_code"
            control={control}
            render={({ field }) => (
              <CSelect
                {...field}
                label="Nhóm NVL"
                options={groups}
                optionAll
                display="label"
                select="value"
                placeholder="Tất cả"
                className="min-w-[250px]"
              />
            )}
          />
        </div>
        <CButton icon={<Magnifying />} onClick={search} className="m-0">
          Tìm kiếm
        </CButton>
      </div>
    </>
  );
  //#endregion
};
